import { Drawer } from '@mui/material';
import Grid from 'components/core/Grid';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  ${props => props.theme.breakpoints.down('sm')} {
    & .MuiDrawer-paper {
      width: 100%;
    }
  }
`;

export const ContactDetail = styled(Grid)`
  & .MuiTypography-root {
    font-weight: 500;

    & a {
      text-decoration: none;
      color: initial;
    }
  }
`;
